import { transport } from 'config/transport';

export function callApiGetReportThuChiCTPV(congDoanId, academicYear) {
    return transport.get(`/ctpv/thuchi/congDoan/${congDoanId}/AnnualReport`, { params: { academicYear } });
}
